/**
 * @owner @Appboy/whats-app
 * WhatsApp List Schema
 *
 * Shared schema for list-message layout structure.
 */

import { z } from "zod";

export const whatsAppListSchema = z
  .object({
    list_button_text: z.string().nullable(),
    list_sections: z.array(
      z.object({
        section_title: z.string().nullable(),
        list_rows: z.array(
          z.object({
            row_title: z.string(),
            row_description: z.string().optional(),
          })
        ),
      })
    ),
  })
  .nullable()
  .optional();
